import script from "./Collaboration.vue?vue&type=script&setup=true&lang=js"
export * from "./Collaboration.vue?vue&type=script&setup=true&lang=js"

import "./Collaboration.vue?vue&type=style&index=0&id=a07789f8&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a07789f8"]])

export default __exports__